import React from 'react';
import { Address } from '../../../../../../../types/Common';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { handleResponseLanguage } from '../../../../../../../i18n';
import GrayTextBox from '../../../../../../company-scan/components/GrayTextBox';
import { AddressInput } from '@wegroup/design-system';
import { useFlowsRouteParams } from '../../../../hooks/useFlowsRouteParams';
import { useFlowsSession } from '../../../../api/getFlowsSessionById';

interface Props {
  question: FlowsQuestion;
}

const AddressInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onChange, onBlur },
    error,
    prefilled,
  } = useFlowInputComponent({ question });

  const { sessionId } = useFlowsRouteParams();
  const session = useFlowsSession(sessionId);

  const partyId = session?.data?.prospect?.id || '';

  const addressAnswer = value as Address | undefined;

  const handleChange = (address?: Address) => {
    onChange({ name: question.id, value: address });
  };

  const handleBlur = () => {
    onBlur({ name: question.id, value });
  };

  return (
    <GrayTextBox mt="4" title={handleResponseLanguage(question.title)} mb="1.5">
      <AddressInput
        name={question.id}
        value={addressAnswer}
        error={error?.message}
        onChange={handleChange}
        onBlur={handleBlur}
        country={addressAnswer?.country_code || ''}
        isPrefilled={prefilled}
        isDisabled={question.rules.is_disabled}
        partyId={partyId}
      />
    </GrayTextBox>
  );
};

export default AddressInputComponent;
